import { TransactionState } from '@app/store/domain';

export type MemberInvitation = {
  id: string;
  email: string;
  role: string;
  status: string;
};

export type PageInfo = {
  hasNextPage: boolean;
  endCursor: string | null;
};

export type PaymentPlan = {
  seats: {
    usedAdditional: number;
  };
};

export type State = {
  pendingInvites: MemberInvitation[];
  pageInfo: PageInfo;
  searchQuery: string;
  error: {
    message: string;
  };
} & TransactionState;

export const defaultState: State = {
  status: 'idle',
  pendingInvites: [],
  pageInfo: {
    hasNextPage: false,
    endCursor: null,
  },
  searchQuery: '',
  error: {
    message: '',
  },
};
